import { render, staticRenderFns } from "./LPGDailyData.vue?vue&type=template&id=2aaa8f01&"
import script from "./LPGDailyData.vue?vue&type=script&lang=js&"
export * from "./LPGDailyData.vue?vue&type=script&lang=js&"
import style0 from "./LPGDailyData.vue?vue&type=style&index=0&id=2aaa8f01&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports